<template>
  <v-dialog v-model="dialog" width="1250px">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
         Airbnb Change requests
       </v-card-title>
       <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ID</th>
                <th class="text-left">Request Date</th>
                <th class="text-left">Adults</th>
                <th class="text-left">Children</th>
                <th class="text-left">Babies</th>
                <th class="text-left">Pets</th>
                <th class="text-left">From Date</th>
                <th class="text-left">To Date</th>
                <th class="text-left">Initiated By</th>
                
                <th class="text-left">Status</th>
                <th class="text-left">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(hoch, i) in huov.hoch"
                :key="i"
              >
                <td>{{ hoch.hoch_id }}</td>
                <td>{{ hoch.hoch_request_dt }}</td>
                <td>{{ hoch.hoch_aant_volw }}</td>
                <td>{{ hoch.hoch_aant_kind }}</td>
                <td>{{ hoch.hoch_aant_baby }}</td>
                <td>{{ hoch.hoch_aant_hd }}</td>
                <td>{{ hoch.hoch_van_datum }}</td>
                <td>{{ hoch.hoch_tm_datum }}</td>
                <td>{{ hoch.hoch_initiated_by }}</td>
                <td>
                    <v-tooltip bottom v-if="hoch.hoch_stat === 'PENDING'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="orange">mdi-clock-outline</v-icon>
                      </template>
                      <span>Pending</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="hoch.hoch_stat === 'ACCEPTED'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="green">mdi-check-circle-outline</v-icon>
                      </template>
                      <span>Accepted</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="hoch.hoch_stat === 'DECLINED'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="red">mdi-close-circle-outline</v-icon>
                      </template>
                      <span>Declined</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="hoch.hoch_stat === 'CANCELLED'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="red">mdi-close-circle-outline</v-icon>
                      </template>
                      <span>Cancelled</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="hoch.hoch_stat === 'VOID'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="red">mdi-close-circle-outline</v-icon>
                      </template>
                      <span>Voided</span>
                    </v-tooltip>
                </td>
                <td>
                  <v-dialog v-model='modals[hoch.hoch_id]' width='1000'>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
                        <v-icon>mdi-text-box-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5 grey lighten-2">
                        Description
                      </v-card-title>
                      <v-card-text>
                        <pre style="white-space: pre-wrap; ">{{ hoch.hoch_oms }}</pre>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        
                        <v-btn color="primary" small @click="modals[hoch.hoch_id] = false">
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      dialogDesc: false,
      huov_encrid: null,
      modals: {},
      huov: {},
    }
  },
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovHoch.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovHoch",
          },
          getHuovHoch: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovHoch;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
